module.exports = __webpack_public_path__ + "823745e2.png";